import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Container, Row, OverlayTrigger, Popover, Spinner } from 'react-bootstrap';
import ChemComponent from '../../ChemComponent';
import QueryTable from '../../QueryTable';
import { Link } from 'react-router-dom';

class CollegeRoomContacts extends ChemComponent {
  	constructor(props) {
		super(props);
		
		this.state = {
			renderKey: 1,
			searchCount: null
		};
	}
	
	onSearchResult(data) {
		this.mergeState({
			searchCount: data.ResultCount
		});
	}
		
	render() {		
	
		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'College Room Contacts',
			columns: exportColumns,
			entity: 'COLLEGE_ROOM_CONTACT_VW',
			order: ['PERSON_NAME','EMAIL']
		});			

		var emailData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'College Room Contacts',
			distinct: true,
			columns: ['EMAIL'],
			entity: 'COLLEGE_ROOM_CONTACT_VW',
			order: ['EMAIL']
		});

		return (<>
			<Container fluid>
				<Row style={{ paddingTop: '20px', paddingBottom: '20px', marginBottom: '20px', border: '1px solid #ccc',
					borderRadius: 6, backgroundColor: '#FEFEFE' }}>
					<Col xs={2}>
						<span style={{ fontSize: '18px', fontWeight: 'bold' }}>College Room Contacts</span>
					</Col>
					<Col xs={2} style={{ marginTop: 2}}>
						{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
					</Col>
					<Col xs={1}>
						<form action={this.getConfig().host + '/Home/Excel'} method='POST'>
							{exportData.map((excelFormField, index) => {
								return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							</OverlayTrigger>
						</form>
					</Col>
					<Col xs={1}>
						<form action={this.getConfig().host + '/Home/Pdf'} method='POST'>
							{exportData.map((pdfFormField, index) => {
								return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							</OverlayTrigger>
						</form>
					</Col>
					<Col xs={1}>
						<form action={this.getConfig().host + '/Home/MailingList'} method='POST'>
							{emailData.map((emailFormField, index) => {
								return (<input key={index} type='hidden' name={emailFormField.name} value={emailFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export Email List</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Email.png'} style={{ paddingLeft: '20px' }} alt="Export Email List" />
							</OverlayTrigger>
						</form>
					</Col>
				</Row>
				<Row>
					<Col>
						<QueryTable renderKey={this.state.renderKey} parent={this} name='BuildingAccess_CollegeRoomContacts' table={contactsList}
							onResult={(data) => this.onSearchResult(data)} offsetHeight='100px' />
					</Col>
				</Row>
			</Container>
		</>);
	}
}

const contactsList = {
	query: { entity: 'COLLEGE_ROOM_CONTACT_VW', order: ['PERSON_NAME','EMAIL'] },
	pageSize: 20,
	columns: [
		{ Header: 'ID', accessor: 'PERSON_ID' },
		{ Header: 'Person', accessor: 'PERSON_NAME', Cell: props => <Link to={'/BuildingAccess/People/' + props.row.values.PERSON_ID}>{props.value}</Link> },
		{ Header: 'Status', accessor: 'TYPE_NAME' },
		{ Header: 'Email', accessor: 'EMAIL', width: 250 }
	]
};

const exportColumns = [
		{ Header: 'ID', accessor: 'PERSON_ID', width: 10 },
		{ Header: 'Person', accessor: 'PERSON_NAME', width: 20 },
		{ Header: 'Status', accessor: 'TYPE_NAME', width: 20 },
		{ Header: 'Email', accessor: 'EMAIL', width: 30 }
];

export default CollegeRoomContacts;